module.exports = __webpack_public_path__ + "media/resumes_and_cover_letters/document-list-bcc980ef.png";